/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
(function ($) {
  var PX_PER_SEC = 80;
  var GAP = 16;
  var SCALE_MIN = 360 / 430;
  var SCALE_MAX = 1;
  var MOBILE_BREAKPOINT = 799;

  var DARK_CLASS  = 'is-dark-context';

  var darkSliders    = [];
  var darkRafPending = false;

  function isMobileMarquee() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function initDarkContext() {
    var $sliders = $('.reviews-slider');
    if (!$sliders.length) return;

    $sliders.each(function () {
      darkSliders.push({ $slider: $(this) });
    });

    updateDarkContext();
    $(window).on('scroll.darkctx resize.darkctx', scheduleDarkUpdate);
  }

  function scheduleDarkUpdate() {
    if (darkRafPending) return;
    darkRafPending = true;
    requestAnimationFrame(function () {
      updateDarkContext();
      darkRafPending = false;
    });
  }

  function updateDarkContext() {
    var ranges = $.map(darkSliders, function (item) {
      if (item.$slider.hasClass('light-version')) {
        return { active: false };
      }
      var rect = item.$slider[0].getBoundingClientRect();
      return {
        active: rect.top < 600 && rect.bottom > 400
      };
    });

    var anyActive = ranges.some(function (r) { return r.active; });
    $('body').toggleClass(DARK_CLASS, anyActive);
  }

  function initPlatforms(sectionId) {
    var $track   = $('#rsp-track-'  + sectionId);
    var $btnPrev = $('#rsp-prev-'   + sectionId);
    var $btnNext = $('#rsp-next-'   + sectionId);
    if (!$track.length || !$btnPrev.length || !$btnNext.length) return;

    var BREAKPOINT = 1279;
    function isMobile() { return $(window).width() <= BREAKPOINT; }

    function update() {
      if (!isMobile()) {
        $btnPrev.add($btnNext).hide();
        return;
      }
      var track     = $track[0];
      var overflows = track.scrollWidth > track.clientWidth + 2;
      var atStart   = track.scrollLeft <= 2;
      var atEnd     = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      $btnPrev.toggle(overflows && !atStart);
      $btnNext.toggle(overflows && !atEnd);
    }

    function scrollByOne(dir) {
      var $items = $track.find('.review-platform');
      var itemW  = $items.length ? $items[0].offsetWidth + 12 : 200;
      $track[0].scrollBy({ left: dir * itemW, behavior: 'smooth' });
    }

    $btnPrev.on('click', function () { scrollByOne(-1); });
    $btnNext.on('click', function () { scrollByOne(1); });
    $track.on('scroll', update);

    // Debounced, same 150ms window as the other resize handlers below —
    // previously this fired on every raw resize event with no throttling.
    var platformsResizeTimer;
    $(window).on('resize.rsPlatforms', function () {
      clearTimeout(platformsResizeTimer);
      platformsResizeTimer = setTimeout(update, 150);
    });

    $(window).on('load', function () {
      update();
      setTimeout(update, 300);
    });
    update();
  }

  // Copy for the read-more toggle lives on the button's data attributes (set by
  // the section from its translatable settings); the English strings are only a
  // fallback for markup rendered before those attributes existed.
  function readMoreLabel($btn) {
    return $btn.attr('data-read-more-text') || 'Read more';
  }

  function readLessLabel($btn) {
    return $btn.attr('data-read-less-text') || 'Read less';
  }

  function checkReadMoreBtns() {
    $('.rs-slide--text').each(function () {
      var $card  = $(this);
      var $clamp = $card.find('.rs-review-clamp');
      var $btn   = $card.find('.rs-read-more-btn');
      if (!$clamp.length || !$btn.length) return;

      if ($(window).width() > 799) {
        $btn.css('display', 'none');
        $card.removeClass('rs-expanded');
        $btn.text(readMoreLabel($btn));
      } else {
        var wasExpanded = $card.hasClass('rs-expanded');
        if (wasExpanded) $card.removeClass('rs-expanded');
        var needsBtn = $clamp[0].scrollHeight > $clamp[0].clientHeight + 2;
        if (wasExpanded) $card.addClass('rs-expanded');

        if (needsBtn) {
          $btn.css('display', 'inline');
        } else {
          $btn.css('display', 'none');
          $card.removeClass('rs-expanded');
          $btn.text(readMoreLabel($btn));
        }
      }
    });
  }

  function initReadMore() {
    setTimeout(checkReadMoreBtns, 100);

    var resizeTimer;
    $(window).on('resize.readmore', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkReadMoreBtns, 150);
    });

    $(document).on('click', '.rs-read-more-btn', function (e) {
      e.stopPropagation();
      var $btn   = $(this);
      var $card  = $btn.closest('.rs-slide--text');
      var isOpen = $card.hasClass('rs-expanded');

      $('.rs-slide--text.rs-expanded').each(function () {
        $(this).removeClass('rs-expanded');
        var $otherBtn = $(this).find('.rs-read-more-btn');
        $otherBtn.text(readMoreLabel($otherBtn));
      });

      if (!isOpen) {
        $card.addClass('rs-expanded');
        $btn.text(readLessLabel($btn));
      }
    });
  }

  function initMarquee(sectionId) {
    var $outer = $('#rs-marquee-' + sectionId);
    if (!$outer.length) return;

    var outer  = $outer[0];
    var $track = $outer.find('.rs-marquee-track');
    var track  = $track[0];
    var slides = track.querySelectorAll('.rs-slide');
    if (!slides.length) return;

    var paused      = false;
    var offset      = 0;
    var lastTime    = null;
    var nudging     = false;
    var rafActive   = false; // controls whether the animate loop is currently running
    var isInViewport = true; // becomes accurate once the IntersectionObserver below fires

    var halfCount = Math.floor(slides.length / 2);
    var setWidth  = 0;
    for (var i = 0; i < halfCount; i++) {
      setWidth += slides[i].offsetWidth + GAP;
    }

    if (setWidth > 0) {
      var origSlides = Array.prototype.slice.call(slides, 0, halfCount);
      var copies = 2;
      while (copies * setWidth < outer.offsetWidth + setWidth) {
        origSlides.forEach(function (s) {
          var clone = s.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        });
        copies++;
      }
      slides = track.querySelectorAll('.rs-slide');
    }

    $outer.css('cursor', 'grab');
    track.style.willChange = 'transform';

    var slideWidths  = [];
    var slideLefts   = [];
    var lastScale    = [];
    var lastOpacity  = [];
    var outerWidth   = 0;

    function measureGeometry() {
      var acc = 0;
      for (var m = 0; m < slides.length; m++) {
        var w = slides[m].offsetWidth;
        slideWidths[m] = w;
        slideLefts[m]  = acc;
        if (lastScale[m] === undefined) {
          lastScale[m]   = 1;
          lastOpacity[m] = '1';
          slides[m].style.willChange = 'transform, opacity';
        }
        acc += w + GAP;
      }
      outerWidth = outer.offsetWidth;
    }
    measureGeometry();

    // If this section happens to init while already on mobile, make sure
    // nothing is left scaled down before the first animate() tick ever runs.
    if (isMobileMarquee()) resetMobileScale();

    var geometryResizeTimer;
    $(window).on('resize.rsMarqueeGeometry', function () {
      clearTimeout(geometryResizeTimer);
      geometryResizeTimer = setTimeout(measureGeometry, 150);
    });

    // Clears any leftover scale/opacity/transform from the desktop marquee
    // animation so the mobile CSS-grid layout always shows slides at 1:1,
    // full opacity, with no stray transform on the track itself.
    function resetMobileScale() {
      track.style.transform = '';
      for (var m = 0; m < slides.length; m++) {
        slides[m].style.transform = 'scale(1)';
        slides[m].style.opacity = '1';
        lastScale[m]   = 1;
        lastOpacity[m] = '1';
      }
    }

    function updateScales() {
      var triggerX = outerWidth * 0.75;

      for (var w = 0; w < slides.length; w++) {
        var slideWidth  = slideWidths[w];
        var slideCenter = (slideLefts[w] - offset) + slideWidth / 2;
        var scale, opacity;

        if (slideCenter > triggerX) {
          var ratio = Math.min(
            (slideCenter - triggerX) / (outerWidth * 0.25 + slideWidth * 0.5),
            1
          );
          scale   = SCALE_MAX - (SCALE_MAX - SCALE_MIN) * ratio;
          opacity = String(1 - ratio * 0.35);
        } else {
          scale   = 1;
          opacity = '1';
        }

        if (lastScale[w] !== scale) {
          slides[w].style.transform = 'scale(' + scale + ')';
          lastScale[w] = scale;
        }
        if (lastOpacity[w] !== opacity) {
          slides[w].style.opacity = opacity;
          lastOpacity[w] = opacity;
        }
      }
    }

    function animate(ts) {
      // Bail out completely once mobile, or once scrolled out of view — no
      // further rAF is scheduled, so the loop actually stops instead of
      // just no-op'ing every frame while off-screen.
      if (isMobileMarquee() || !isInViewport) {
        rafActive = false;
        lastTime  = null;
        return;
      }

      if (lastTime === null) lastTime = ts;
      var delta = ts - lastTime;
      lastTime  = ts;

      if (!paused && !nudging) {
        offset += PX_PER_SEC * (delta / 1000);
        if (offset >= setWidth) offset -= setWidth;
        track.style.transform = 'translateX(-' + offset + 'px)';
        updateScales();
      }

      requestAnimationFrame(animate);
    }

    function startAnimateLoop() {
      if (rafActive || isMobileMarquee() || !isInViewport) return;
      rafActive = true;
      lastTime  = null;
      requestAnimationFrame(animate);
    }

    // Pause the rAF loop entirely while the marquee is scrolled out of view,
    // and resume it once it's back near the viewport. This is the main fix
    // for the constant background CPU cost: previously animate() ran at 60fps
    // for the whole session regardless of scroll position.
    if ('IntersectionObserver' in window) {
      var marqueeVisibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isInViewport = entry.isIntersecting;
          if (isInViewport) {
            startAnimateLoop();
          }
          // When it leaves, animate() sees isInViewport === false on its next
          // tick and stops itself (sets rafActive = false), so no explicit
          // rafActive reset is needed here.
        });
      }, { root: null, rootMargin: '100px', threshold: 0 });
      marqueeVisibilityObserver.observe(outer);
    }

    // Re-check on resize: if the viewport crosses back above the breakpoint
    // (e.g. rotating a tablet, or resizing a browser window), resume the loop.
    var mq = window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)');
    function handleMqChange(e) {
      if (e.matches) {
        // Entered mobile: animate() will see isMobileMarquee() === true on
        // its next tick and stop itself, but any scale/opacity already
        // applied to slides needs to be explicitly reset here — otherwise
        // whatever was mid-transition on desktop stays stuck on mobile.
        resetMobileScale();
      } else {
        startAnimateLoop();
      }
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', handleMqChange);
    } else if (mq.addListener) {
      mq.addListener(handleMqChange); // Safari fallback
    }

    var slideWidth = slides[0].offsetWidth + GAP;
    var nudgeId    = 0;

    function nudge(dir) {
      if (isMobileMarquee()) return; // grid layout on mobile — nav arrows don't apply
      var myId = ++nudgeId;
      nudging  = true;
      paused   = false;
      var target = offset + dir * slideWidth * 2;
      target = ((target % setWidth) + setWidth) % setWidth;
      var start = offset;
      var diff  = target - start;
      if (diff >  setWidth / 2) diff -= setWidth;
      if (diff < -setWidth / 2) diff += setWidth;
      var startTs = null;
      var duration = 500;

      function ease(ts) {
        if (myId !== nudgeId) return;
        if (startTs === null) startTs = ts;
        var t = Math.min((ts - startTs) / duration, 1);
        var eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        offset = ((start + diff * eased) % setWidth + setWidth) % setWidth;
        track.style.transform = 'translateX(-' + offset + 'px)';
        updateScales();
        if (t < 1) {
          requestAnimationFrame(ease);
        } else {
          nudging  = false;
          lastTime = null;
        }
      }
      requestAnimationFrame(ease);
    }

    $('#rs-prev-' + sectionId).on('click', function () { nudge(-1); });
    $('#rs-next-' + sectionId).on('click', function () { nudge(1); });

    $(document).on('keydown', function (e) {
      if (isMobileMarquee()) return;
      if (e.key === 'ArrowLeft')  nudge(-1);
      if (e.key === 'ArrowRight') nudge(1);
    });

    $outer.on('wheel', function (e) {
      if (isMobileMarquee()) return;
      var oe = e.originalEvent;
      if (Math.abs(oe.deltaX) < Math.abs(oe.deltaY) && Math.abs(oe.deltaY) > 5) return;
      e.preventDefault();
      offset = ((offset + oe.deltaX) % setWidth + setWidth) % setWidth;
      track.style.transform = 'translateX(-' + offset + 'px)';
      updateScales();
      lastTime = null;
    });

    var dragStartX   = 0;
    var offsetAtDrag = 0;
    var isDragging   = false;
    var hasDragged   = false;

    $outer.on('mousedown', function (e) {
      if (isMobileMarquee()) return;
      isDragging   = true;
      hasDragged   = false;
      dragStartX   = e.clientX;
      offsetAtDrag = offset;
      nudging      = true;
      $outer.css('cursor', 'grabbing');
    });

    $(window).on('mousemove', function (e) {
      if (!isDragging) return;
      var dx = dragStartX - e.clientX;
      if (Math.abs(dx) > 5) hasDragged = true;
      offset = ((offsetAtDrag + dx) % setWidth + setWidth) % setWidth;
      track.style.transform = 'translateX(-' + offset + 'px)';
      updateScales();
    });

    $(window).on('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      nudging    = false;
      lastTime   = null;
      $outer.css('cursor', 'grab');
    });

    var touchStartX   = 0;
    var offsetAtTouch = 0;

    outer.addEventListener('touchstart', function (e) {
      if (isMobileMarquee()) return; // mobile uses static grid, not a draggable track
      touchStartX   = e.touches[0].clientX;
      offsetAtTouch = offset;
      hasDragged    = false;
      nudging       = true;
      paused        = false;
    }, { passive: true });

    outer.addEventListener('touchmove', function (e) {
      if (isMobileMarquee()) return;
      var dx = touchStartX - e.touches[0].clientX;
      if (Math.abs(dx) > 5) hasDragged = true;
      offset = ((offsetAtTouch + dx) % setWidth + setWidth) % setWidth;
      track.style.transform = 'translateX(-' + offset + 'px)';
      updateScales();
    }, { passive: true });

    outer.addEventListener('touchend', function () {
      if (isMobileMarquee()) return;
      nudging  = false;
      lastTime = null;
    });

    $outer.on('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    });

    $(document).on('click', '.rs-slide--video[data-href]', function (e) {
      if (!$(e.target).closest('.rs-video__ig-link').length && !hasDragged) {
        window.open($(this).data('href'), '_blank');
      }
    });

    var videos = track.querySelectorAll('.rs-video');

    // Attach the video's real sources (stored in data-src) only on demand.
    // Until this runs, preload="none" + no src means zero network usage.
    function hydrateVideo(video) {
      if (video.dataset.rsHydrated) return;
      var sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) return;
      video.dataset.rsHydrated = '1';
      $(sources).each(function () {
        this.src = this.getAttribute('data-src');
      });
      video.load();
    }

    if ('IntersectionObserver' in window) {
      // Load + play a video only once it enters the viewport; pause when it leaves.
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            hydrateVideo(video);
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { root: null, rootMargin: '200px', threshold: 0.1 });
      $(videos).each(function () { videoObserver.observe(this); });
    } else {
      // No IntersectionObserver support: fall back to hydrating + playing all.
      $(videos).each(function () {
        hydrateVideo(this);
        this.play().catch(function () {});
      });
    }

    // Only kick off the animation loop when we're actually above the
    // mobile breakpoint — on mobile the track is a static CSS grid.
    startAnimateLoop();
  }

  function initAll() {
    if ($(window).width() > 800) {
      var sr = ScrollReveal();

      sr.reveal('.reviews-slider__content', {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });

      sr.reveal('.rs-marquee-outer', {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });

      sr.reveal('.reviews-slider__nav', {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });
    }

    var ids = window.__rsMarqueeId || [];
    $.each(ids, function (_, id) {
      initPlatforms(id);
      initMarquee(id);
    });

    initReadMore();
    initDarkContext();
  }

  $(initAll);
}(jQuery));